module.exports = __webpack_public_path__ + "static/media/minus.73d73288.svg";